export const ERROR_DISPLAY_TYPES = {
  FORM: "form",
  TOAST: "toast",
  ALERT: "alert",
} as const;
export type ErrorDisplayType =
  (typeof ERROR_DISPLAY_TYPES)[keyof typeof ERROR_DISPLAY_TYPES];
